/**
 * PWA 설치 prompt 헬퍼.
 *
 *  - Chrome / Edge / Samsung Internet:
 *      'beforeinstallprompt' 이벤트가 발생 → preventDefault() 로 자동 배너 숨기고
 *      나중에 사용자가 버튼 누를 때 prompt() 호출.
 *  - iOS Safari: 이벤트 자체가 없음. UA 로 감지해서 '공유 → 홈 화면에 추가' 안내.
 *  - 이미 설치되어 standalone 으로 실행 중이면 버튼 자체를 안 보임.
 *
 * 모듈 로드 시점에 한 번만 listener 등록. 컴포넌트는 subscribeInstallState 로 상태 변화 구독.
 */

let deferredPrompt = null;
const listeners = new Set();

const notify = () => listeners.forEach(fn => {
  try { fn(); } catch (e) { /* ignore */ }
});

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", e => {
    // 자동 배너 막고 우리 버튼 노출용으로 가로챔
    e.preventDefault();
    deferredPrompt = e;
    notify();
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    notify();
  });
}

export const isStandalone = () => {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia && window.matchMedia("(display-mode: standalone)").matches
  ) || window.navigator.standalone === true;
};

export const isIos = () => {
  if (typeof navigator === "undefined" || typeof window === "undefined") return false;
  // iPadOS 13+ 는 desktop UA 라 maxTouchPoints 도 같이 봄
  const ua = navigator.userAgent || "";
  const iOSLike = /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  return iOSLike && !window.MSStream;
};

export const canPromptInstall = () => deferredPrompt !== null;

export const promptInstall = async () => {
  if (!deferredPrompt) return "unavailable";
  deferredPrompt.prompt();
  let outcome = "dismissed";
  try {
    const choice = await deferredPrompt.userChoice;
    outcome = choice && choice.outcome;
  } catch (e) {
    // ignore
  }
  deferredPrompt = null;
  notify();
  return outcome;
};

export const subscribeInstallState = fn => {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
};
